// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1puIq","unreadBadge":"styles_unreadBadge__5JXsq","modalContent":"styles_modalContent__2T8bQ","modal":"styles_modal__XqCIK"};